import { render } from "./WorkOrderSummary.vue?vue&type=template&id=48ff86ec"
import script from "./WorkOrderSummary.vue?vue&type=script&lang=js"
export * from "./WorkOrderSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__